import GenerationPage from "./GenerationPage";

export default GenerationPage;